import { render, staticRenderFns } from "./PropertyHeatConsumption.vue?vue&type=template&id=010ebb8d&lang=pug&"
import script from "./PropertyHeatConsumption.vue?vue&type=script&lang=ts&"
export * from "./PropertyHeatConsumption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports